module.exports = __webpack_public_path__ + "img/Bodice-Back-Ja-Kd-Ld.8ba04aec.png";